import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { I18n } from "@jti/ui/components/I18n";
import { useTranslations } from "@jti/ui/providers/useTranslations";
export const ConsumablesQuantityItemText = ({ quantity, contentsType, itemsPerPackage, }) => {
    const { __ } = useTranslations();
    const secondaryText = __(`consumablesForm.step.quantity_selection.button.text.additional.${contentsType}`, [
        itemsPerPackage * quantity,
    ]);
    return (_jsxs(I18n, { t: `consumablesForm.step.quantity_selection.button.text.${contentsType}`, children: [quantity, secondaryText && _jsx("span", { children: secondaryText })] }));
};
//# sourceMappingURL=ConsumablesQuantityItemText.js.map